// extracted by mini-css-extract-plugin
export default {"containerBtnIcon":"MyAccount-module--containerBtnIcon--I7PkN","subMenuPosY":"MyAccount-module--subMenuPosY--5as01"};